import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const fetchCurrencyData = createAsyncThunk("currency/fetchData", async () => {
    try {
        const response = await api.get("/currencies");
        const data = response.data.data;
        return data;
    } catch (error) {
        return error;
    }
});
export const currencySlice = createSlice({
    name: "currency",
    initialState: {
        loading: false,
        error: null,
        currencies: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCurrencyData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCurrencyData.fulfilled, (state, action) => {
                state.loading = false;
                state.currencies = action.payload;
            })
            .addCase(fetchCurrencyData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default currencySlice.reducer;